import { useEffect, useState } from 'react';
import * as zy from '../../common/zeroyear-1.0.0';

export default function Contact () {
    const [data, setData] = useState([]);
    const selectData = () => {
        zy.select('selectFooter', [], (item) => {
            setData(item[0]);
        });
    };
    useEffect(() => {
        selectData();
    }, []);
    return (
        <section id="contact" className="contact"style={{padding: '20px'}} >
        <div className="container">

            <div className="section-title">
            <span>문의정보</span>
            <h2>문의정보</h2>
            </div>
            <div className="row" data-aos="fade-up">
                <div className="col-lg-4 col-md-6">
                    <div className="info-box mb-4">
                    <i className="bx bx-phone-call"></i>
                    <h3>TEL</h3>
                    <p>{data.FOOT_COMP_TEL}</p>
                    </div>
                </div>
                {/* <div className="col-lg-6"> */}
                <div className="col-lg-4 col-md-6">
                    <div className="info-box mb-4">
                    <i className="bx bx-printer"></i>
                    <h3>FAX</h3>
                    <p>{data.FOOT_COMP_FAXA}</p>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6">
                    <div className="info-box mb-4">
                    <i className="bx bx-envelope"></i>
                    <h3>E-mail</h3>
                    <p>{data.FOOT_COMP_EMAIL}</p>
                    </div>
                </div>
            </div>
        </div>
        </section>
    );
}